module.exports = __webpack_public_path__ + "img/koenen1-min.f8af1438.jpg";